// extracted by mini-css-extract-plugin
export var arbiterBadgeContainer = "_15-0";
export var colorSwatch = "_15-5";
export var fillWidth = "_15-4";
export var iconButton = "_15-2";
export var iconWrapper = "_15-3";
export var shadow = "_15-6";
export var xs = "_15-1";